import { defineComponent as _defineComponent } from 'vue'
import type { View } from '@ilteducation/content-collections-types';


type Props = {
  title: string;
  item?: View;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  item?: View;
}



return { __sfc: true,props }
}

})